import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgChevronIconSecondary from './svgs/ChevronIconSecondary.js';
import SvgChevronIcon from './svgs/ChevronIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ChevronIcon = (props => useIcon(SvgChevronIcon, SvgChevronIconSecondary, props));

export { ChevronIcon as default };
